import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editRoomUser",
  tabindex: "-1",
  "aria-labelledby": "editRoomUser",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroup"
}
const _hoisted_6 = { class: "row mx-5 px-0 gx-3 my-4" }
const _hoisted_7 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_8 = { class: "col-lg-8 gx-0 mx-0" }
const _hoisted_9 = { class: "row mx-5 px-0 gx-3 mb-4" }
const _hoisted_10 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_11 = { class: "col-lg-8 gx-0 mx-0 d-flex fs-7" }
const _hoisted_12 = { class: "me-2 mx-2" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "row mx-5 px-0 gx-3 mb-4" }
const _hoisted_16 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_17 = { class: "col-lg-8 gx-0 mx-0 d-flex fs-7" }
const _hoisted_18 = { class: "text-break break-spaces" }
const _hoisted_19 = { class: "row mx-5" }
const _hoisted_20 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_21 = { class: "col-lg-2 w-max-content" }
const _hoisted_22 = { class: "row mx-0 px-0 col-lg-7 mb-5" }
const _hoisted_23 = { class: "form-check col-lg-3" }
const _hoisted_24 = ["for"]
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "form-check col-lg-6" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_30 = {
  class: "modal fade",
  id: "confirmModalEditRoomUser",
  tabindex: "-1",
  "aria-labelledby": "confirmModalEditRoomUser",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "modal-dialog modal-lg" }
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = { class: "modal-header" }
const _hoisted_34 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "row mx-5 px-0 gx-3 my-4" }
const _hoisted_38 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_39 = { class: "col-lg-8 gx-0 mx-0" }
const _hoisted_40 = { class: "row mx-5 px-0 gx-3 mb-4" }
const _hoisted_41 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_42 = { class: "col-lg-8 gx-0 mx-0 d-flex fs-7" }
const _hoisted_43 = { class: "me-2 mx-2" }
const _hoisted_44 = { class: "me-2" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "row mx-5 px-0 gx-3 mb-4" }
const _hoisted_47 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_48 = { class: "col-lg-8 gx-0 mx-0 d-flex fs-7" }
const _hoisted_49 = { class: "text-break break-spaces" }
const _hoisted_50 = { class: "row mx-5 px-0 gx-3" }
const _hoisted_51 = { class: "col-lg-3 fw-bold" }
const _hoisted_52 = { class: "col-lg-8" }
const _hoisted_53 = { class: "text-break break-spaces" }
const _hoisted_54 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_55 = {
  class: "modal fade",
  id: "editSuccessUser",
  tabindex: "-1",
  "aria-labelledby": "editSuccessUser",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "modal-dialog" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = {
  class: "modal-title text-center fw-bold w-100",
  id: "editSuccessUser"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_61 = { class: "" }
const _hoisted_62 = { class: "text-center my-4" }
const _hoisted_63 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

//validate
import useVuelidate from '@vuelidate/core'

//constant
import { computed, onMounted, ref, watchEffect } from 'vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { GROUPS_STORE } from '@/store/constants'
import UserAliasIcon from '@/components/user-alias-icon'
import Status from '@/components/status/index.vue'
import { required } from '@vuelidate/validators'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  talkRoomId: String,
  count: Number,
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const loadingEditUser = ref<boolean>(false)
const editFailedUser = ref<boolean>(false)
const detailTalkRoom = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_TALK_ROOM])


const rules = computed(() => {
  return {
    published: { required },
  }
})

const formData = ref({
  published: '',
})
watchEffect(() => {
  if (props.talkRoomId && props.count)
    formData.value = {
      published: detailTalkRoom.value?.published,
    }
})

const v$ = useVuelidate(rules, formData)

const onSubmit = (): void => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }
}
// 2022/09/12 TienNV Fix double click button confirm edit user
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('confirmModalEditRoomUser'))
  modalSuccess.value = new Modal(document.getElementById('editSuccessUser'))
})

const EditRoom = async (): void => {
  loadingEditUser.value = true
  try {
    const response = await groupsService.editTalkRoomApi(props.talkRoomId, { talkroom: formData.value, create_by_admin: true })
    if (response?.status === 200) {
      editFailedUser.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: {
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
    } else {
      editFailedUser.value = true
    }
    // 2022/09/12 TienNV Fix double click button confirm edit user
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingEditUser.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    editFailedUser.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loadingEditUser.value = false
  }
}

const resetData = async () => {
  formData.value = {
    published: detailTalkRoom.value?.published,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('talkRoomName')), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(detailTalkRoom)?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(UserAliasIcon), {
                  userType: _unref(detailTalkRoom)?.admin?.user_type
                }, null, 8, ["userType"]),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(detailTalkRoom)?.admin?.management_no), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(detailTalkRoom)?.admin?.family_name + ' ' + _unref(detailTalkRoom)?.admin?.given_name), 1),
                ([2].includes(_unref(detailTalkRoom)?.admin?.user_type))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "(" + _toDisplayString(_unref(detailTalkRoom)?.admin?.display_name) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(detailTalkRoom)?.information), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.public
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.public,
                      value: true,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_25), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                  ], 8, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.private
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.private,
                      value: false,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_28), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                  ], 8, _hoisted_27)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                class: "button-confirm-modal",
                "data-bs-dismiss": "modal",
                className: 'fw-bold',
                onClick: resetData
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                dataBsToggle: !_unref(v$).$invalid ? 'modal' : '',
                "data-bs-target": '#confirmModalEditRoomUser',
                className: 'fw-bold'
              }, null, 8, ["title", "dataBsToggle"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("h5", _hoisted_34, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _hoisted_35
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('talkRoomName')), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(detailTalkRoom)?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('creator')), 1),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_unref(UserAliasIcon), {
                    userType: _unref(detailTalkRoom)?.admin?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(detailTalkRoom)?.admin?.management_no), 1),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_unref(detailTalkRoom)?.admin?.family_name + ' ' + _unref(detailTalkRoom)?.admin?.given_name), 1),
                  ([2].includes(_unref(detailTalkRoom)?.admin?.user_type))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, "(" + _toDisplayString(_unref(detailTalkRoom)?.admin?.display_name) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(translate)('explanatoryText')), 1),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(detailTalkRoom)?.information), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("p", _hoisted_53, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#editRoomUser',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: 'secondary',
                className: 'fw-bold',
                loading: loadingEditUser.value,
                disabled: loadingEditUser.value,
                onClick: EditRoom
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("h5", _hoisted_59, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _hoisted_60
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("p", _hoisted_62, _toDisplayString(editFailedUser.value ? _unref(translate)('SO10editTalkRoomError') : _unref(translate)('OC42editTitleMess')), 1)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})